import { useState, useEffect } from 'react';
import { apiService } from '../services/apiService';
import car_image_1 from '../pages/assets/car_image_1.svg';
import car_image_2 from '../pages/assets/car_image_2.svg';

// Default images fallback
const defaultImages = [car_image_1, car_image_2, car_image_2];

/**
 * Custom hook to fetch featured cars and return image URLs
 * Falls back to default images if no featured cars are available
 * @returns {Object} { images, loading, error }
 */
export const useFeaturedCars = () => {
  const [images, setImages] = useState(defaultImages);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeaturedCars = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await apiService.getPublicFeaturedCars();
        const featuredCars = response.data?.featuredCars || [];
        
        if (featuredCars.length > 0) {
          // Extract image URLs from featured cars
          const featuredImages = featuredCars
            .map(car => car.imageUrl)
            .filter(url => url && url.trim() !== '');
          
          if (featuredImages.length > 0) {
            // Use featured images, ensure we have at least 3 for carousel
            let finalImages = featuredImages;
            if (featuredImages.length < 3) {
              // Repeat images to have at least 3
              while (finalImages.length < 3) {
                finalImages = [...finalImages, ...featuredImages];
              }
              finalImages = finalImages.slice(0, 3);
            }
            setImages(finalImages);
          } else {
            // No valid image URLs, use defaults
            setImages(defaultImages);
          }
        } else {
          // No featured cars, use defaults
          setImages(defaultImages);
        }
      } catch (err) {
        console.error('Error fetching featured cars:', err);
        setError(err);
        // On error, use default images
        setImages(defaultImages);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedCars();
  }, []);

  return { images, loading, error };
};

